import { render, staticRenderFns } from "./my-uploaded-documents.vue?vue&type=template&id=61067d42"
import script from "./my-uploaded-documents.vue?vue&type=script&lang=ts"
export * from "./my-uploaded-documents.vue?vue&type=script&lang=ts"
import style0 from "./my-uploaded-documents.vue?vue&type=style&index=0&id=61067d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports